module.exports = __webpack_public_path__ + "img/AI (3).23a27ca7.png";